import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import { md, initClipboard } from '@/utils/markdown';
import WebQuery from '@/components/web-query.vue';
import LawQuery from '@/components/law-query.vue';
import Searching from '@/components/searching.vue';
import AiAnswerButton from './ai-answer-button.vue';
import { mapGetters } from 'vuex';
import RecommendLaw from '@/views/compliance/home/recommend-law/index.vue';
import mermaid from 'mermaid';
export default {
  components: {
    RecommendLaw: RecommendLaw,
    AiAnswerButton: AiAnswerButton,
    WebQuery: WebQuery,
    LawQuery: LawQuery,
    Searching: Searching
  },
  props: {
    answer: {
      // 回答的答案对象
      type: Object,
      default: function _default() {
        return {
          list: []
        };
      }
    },
    question: {
      // 问题对象
      type: Object,
      default: function _default() {
        return {
          content: ''
        };
      }
    },
    showLibraryQueryTag: {
      // 是否显示知识库标签（盛瑞知识库）
      type: Boolean,
      default: true
    },
    showLawQueryTag: {
      // 是否显示法规查询标签（盛瑞法规查询）
      type: Boolean,
      default: true
    },
    showWebQueryTag: {
      // 是否显示联网查找标签（博查）
      type: Boolean,
      default: true
    },
    showEvaluate: {
      // 显示点赞/点踩
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  watch: {
    'answer.content': {
      handler: function handler(newValue, oldValue) {
        mermaid.init(undefined, document.querySelectorAll('.mermaid'));
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('ai', ['aiLoading', 'qaId'])), {}, {
    // 获取最后一条回复
    lastAnswer: function lastAnswer() {
      if (this.answer && this.answer.list && this.answer.list.length > 0) {
        return this.answer.list[this.answer.list.length - 1];
      }
      return {};
    },
    /**
     * 是否显示
     * @returns {boolean}
     */
    currentAnswerShowEvaluate: function currentAnswerShowEvaluate() {
      return !(this.answer.id === this.qaId && this.aiLoading);
    },
    /**
     * 是否显示推荐法规
     * @returns {boolean}
     */
    currentAnswerShowRecommendLaw: function currentAnswerShowRecommendLaw() {
      return this.answer.id === this.qaId && !this.aiLoading;
    }
  }),
  updated: function updated() {
    this.$eventBus.$emit('auto-scroll');
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      initClipboard();

      // 页面加载完成后强制 MathJax 渲染
      if (window.MathJax) {
        window.MathJax.typeset();
      }
      mermaid.init(undefined, document.querySelectorAll('.mermaid'));
    });
  },
  methods: {
    /**
     * 回答内容中只要有表格就显示特定问题
     */
    showRecommend: function showRecommend(answer) {
      var html = this.renderMarkDown(answer);
      var includeTable = html.includes('<table  style="border-collapse: collapse; width: 100%;">') && html.includes('</table>');

      // 正在输出的时候，等待输出结束后再显示推荐气泡
      if (this.answer.id === this.qaId) {
        if (!this.aiLoading) {
          return includeTable;
        } else {
          return false;
        }
      } else {
        // 不是当前输出直接判断是否显示气泡
        return includeTable;
      }
    },
    /**
     * 过滤工作流字数小于5，并且包含，"你好，您好"字眼
     * @param content
     * @returns {false|*}
     */
    filterThinkingFlow: function filterThinkingFlow(_ref) {
      var content = _ref.content;
      return content.length < 5 && (content.includes('你好') || content.includes('您好'));
    },
    /**
     * 发送
     * @param msg
     */
    sendHandler: function sendHandler(msg) {
      this.$store.dispatch('ai/setValue', {
        key: 'sendHandler',
        value: {
          send: true,
          message: msg
        }
      });
    },
    /**
     * 渲染markdown 内容
     * @param answer
     * @returns {*}
     */
    renderMarkDown: function renderMarkDown(answer) {
      var content = answer.content;
      var message = content.replaceAll('\\n', '\n');
      return md.render(message);
    }
  }
};